import type { TopicScore } from "sj-ui-toolkit/src/client/svcProctor";

import S from "./Assessments.module.scss";

/** Topic list (proficiencies or growth opportunities) */
const TopicList = ({
  heading,
  topics,
  variant,
}: {
  heading: string;
  topics: TopicScore[];
  variant: "proficiency" | "growth";
}) => {
  if (!topics.length) return null;
  const iconClass = variant === "growth" ? S.topicIconWarning : S.topicIconCheck;
  const iconSymbol = variant === "growth" ? "⚠" : "✓";
  // Screen reader status text — ensures meaning isn't conveyed by icon/color alone (WCAG 1.4.1)
  const statusText = variant === "growth" ? "Growth opportunity:" : "Proficient:";

  return (
    <div className={S.topicListColumn}>
      <h4 className={S.topicListHeading}>{heading}</h4>
      <ul className="list-none p-0 m-0">
        {topics.map(t => (
          <li key={t.fullPath} className={S.topicItem}>
            <span className={iconClass} aria-hidden="true">
              {iconSymbol}
            </span>
            <span className="sr-only">{statusText}</span>
            <span>{t.pathTitle ?? t.fullPath}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export { TopicList };
